import { TranscriptionService, ServiceConfiguration } from '../types';
import { apiClient } from './api';

class ServiceConfigurationService {
  private baseUrl = '/service/configuration';

  async getConfiguration(): Promise<ServiceConfiguration> {
    const response = await apiClient.get<ServiceConfiguration>(this.baseUrl);
    return response.data;
  }

  /**
   * Validates a file against the current service configuration
   */
  validateFile(
    file: File,
    configuration: ServiceConfiguration
  ): { isValid: boolean; errors: string[] } {
    const errors: string[] = [];

    // Check file size
    if (file.size > configuration.file_constraints.max_file_size) {
      const maxSizeMB = Math.round(
        configuration.file_constraints.max_file_size / (1024 * 1024)
      );
      errors.push(`File size exceeds maximum allowed size of ${maxSizeMB}MB`);
    }

    // Check file format
    const fileType = file.type;
    if (!configuration.file_constraints.supported_formats.includes(fileType)) {
      errors.push(
        process.env.REACT_APP_TRANSCRIBING_SERVICE_SELECTION === 'true'
          ? `File format "${fileType}" is not supported by the active transcription service (${configuration.transcription.active_service_name})`
          : `File format "${fileType}" is not supported`
      );
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }

  /**
   * Gets available transcription services for user selection
   */
  getAvailableServices(
    configuration: ServiceConfiguration
  ): TranscriptionService[] {
    return configuration.transcription.all_services.filter(
      (service) => service.available
    );
  }
}

export const serviceConfigurationService = new ServiceConfigurationService();
